import { render, staticRenderFns } from "./generalSituation.vue?vue&type=template&id=de263248&scoped=true"
import script from "./generalSituation.vue?vue&type=script&lang=js"
export * from "./generalSituation.vue?vue&type=script&lang=js"
import style0 from "./generalSituation.vue?vue&type=style&index=0&id=de263248&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de263248",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('de263248')) {
      api.createRecord('de263248', component.options)
    } else {
      api.reload('de263248', component.options)
    }
    module.hot.accept("./generalSituation.vue?vue&type=template&id=de263248&scoped=true", function () {
      api.rerender('de263248', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/member/userDetails/components/generalSituation.vue"
export default component.exports